import { VideogularComponent } from 'vbrick-player-src/videogular/Videogular.Component';

import { HlsPlayer } from './HlsPlayer';
import { IRevConnectInfo } from '@vbrick/vbrick-rev-connect/src/IRevConnectInfo';
import { HlsConfig } from 'hls.js';

export class HlsPeerPlayer extends HlsPlayer {
	constructor(
		src: string,
		videoElement: HTMLVideoElement,
		API: VideogularComponent,
		isLive: boolean,
		hlsJsConfigOverrides: Partial<HlsConfig>,
		isStartPrefetch?: boolean,
		protected revConnectInfo?: IRevConnectInfo
	) {
		super(src, videoElement, API, isLive, hlsJsConfigOverrides, isStartPrefetch);
	}

	protected initHlsJsPlayer(): Promise<void> {

		//only load rev connect for primary player. content player pLoader and fLoader comes from primary player.
		if (this.isPrimaryPlayer && this.isLive && this.revConnectInfo) {
			return import(/* webpackChunkName: "vbrick-rev-connect" */ '@vbrick/vbrick-rev-connect/dist/vbrick-rev-connect')
				.then(exports => {
					const createLoader = (wrapperMethod: any) => {
						return (window as any).vbRevConnect[wrapperMethod](
							this.Hls.DefaultConfig.loader,
							this.revConnectInfo,
							reason => {
								const errorEvent: Event & { details?: any } = this.createEvent('hlsNonRecoverableError');
								errorEvent.details = reason;

								this.API.onVideoError(errorEvent);
							}
						);
					};

					this.hlsJsConfigOverrides.fLoader = createLoader('revConnectFragmentsForVbrickWrapper');
					this.hlsJsConfigOverrides.pLoader = createLoader('revConnectPlaylistsForVbrickWrapper');
				})
				.then(() => super.initHlsJsPlayer());
		}

		return super.initHlsJsPlayer();
	}

	public destroy(): void {
		const { fLoader } = this.hlsJsConfigOverrides as any;

		if (fLoader && fLoader.destroy) {
			fLoader.destroy();
		}

		super.destroy();
	}
}
